export const isRemoveTagAction = (action?: string) =>
  action === "remove-value" || action === "pop-value";

export const tagFromSelectOperation = (
  operation: {
    action?: string;
    removedValue?: { data?: { tag?: unknown } };
    option?: { data?: { tag?: unknown } };
  },
  newValue: { data?: { tag?: unknown } } | undefined,
  isMulti: boolean
) => {
  if (isRemoveTagAction(operation.action)) {
    return operation.removedValue?.data?.tag;
  }
  if (operation.action === "select-option") {
    return (isMulti ? operation.option : newValue)?.data?.tag;
  }
  return undefined;
};
